import React from 'react';
import {
  AppTranslationEntry,
  RequestUploadUrlType,
} from '../../graphql/generatedTypes';
import { IconButton } from '../../components/Button/Button';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { useOnUploadFileHook } from '../../hooks/useOnUploadFileHook';
import { useUpdateAppTranslationMutation } from '../../graphql/mutations/updateAppTranslation.generated';
import { FaSave } from 'react-icons/fa';

export function EditAppTranslationForm({
  translation,
}: {
  translation: AppTranslationEntry;
}) {
  const [name, setName] = React.useState<string>(translation.name);
  const [url, setUrl] = React.useState<string>(translation.url);

  const [updateAppTranslation, { loading: updatingAppTranslation }] =
    useUpdateAppTranslationMutation();

  const {
    getUrlForS3FileUploadOnFileInputChangeEvent,
    loading: uploadingFile,
  } = useOnUploadFileHook(RequestUploadUrlType.AppTranslation);

  async function onFileUploadInputChange(
    e: React.ChangeEvent<HTMLInputElement>,
  ) {
    const url = await getUrlForS3FileUploadOnFileInputChangeEvent(e);
    if (url) {
      setUrl(url);
    }
  }

  async function onSaveClick() {
    await updateAppTranslation({
      variables: {
        input: {
          id: translation.id,
          name,
          url,
        },
      },
    });
  }

  const translationChanged =
    name !== translation.name || url !== translation.url;

  return (
    <>
      <FormGroup row>
        <Label for="name" sm={2}>
          Name
        </Label>
        <Col sm={10}>
          <Input
            type="text"
            name="name"
            id="name"
            placeholder="Translation name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="name" sm={2}>
          Json File
        </Label>
        <Col sm={10}>
          <Input
            type="file"
            name="name"
            id="name"
            placeholder="Translation name"
            onChange={onFileUploadInputChange}
          />
          {uploadingFile && <div>Uploading file...</div>}
        </Col>
      </FormGroup>
      <IconButton
        size="sm"
        label={!updatingAppTranslation ? 'Update translation' : 'Loading...'}
        icon={<FaSave />}
        onClick={onSaveClick}
        disabled={
          !translationChanged || uploadingFile || updatingAppTranslation
        }
      ></IconButton>
      <br />
      <br />
    </>
  );
}
